exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-1F-94{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"container": "container-1F-94"
};